import React from 'react';
import { createRoot } from 'react-dom/client';
// eslint-disable-next-line
import {
  GoogleOAuthProvider,
  GoogleLogin,
  googleLogout,
} from '@react-oauth/google';
import { SWRConfig } from 'swr';
import { StyledEngineProvider, ThemeProvider, createTheme } from '@mui/material/styles';
import { dataFetcher } from 'Api';
import AOS from 'aos';
// import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from 'store/store';
import { resumeUiSwitchOverlay } from 'Utils/uiSwitchOverlay';
import GoogleJson from './Config/Google.json';
import { App } from './app';
// import './index.css';
import 'aos/dist/aos.css';

// If a new⇄classic UI switch is mid-reload, cover the screen before React paints
// so the fresh app mounts behind the overlay (no page flash).
resumeUiSwitchOverlay();

AOS.init();
// MUI v5 default theme, shared by emotion (@mui/material) and the @mui/styles JSS
// bridge (makeStyles/withStyles). injectFirst puts emotion's styles at the top of
// <head> so the app's CSS-modules/JSS keep winning the specificity war (as they did
// under MUI v4) instead of being overridden by emotion.
const muiTheme = createTheme();
const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <SWRConfig
      value={{
        fetcher: dataFetcher,
        revalidateOnFocus: false,
        revalidateOnMount: false,
        shouldRetryOnError: false,
      }}
    >
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={muiTheme}>
          <GoogleOAuthProvider clientId={GoogleJson?.web?.client_id}>
            <App />
          </GoogleOAuthProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </SWRConfig>
  </Provider>,
);
// reportWebVitals();
